export default function headersForAjaxJson() {
  const csrfElement = document.getElementsByName('csrf-token');
  const csrfToken = csrfElement.length > 0 ? csrfElement[0].content : null;
  return {
    'Content-type': 'application/json',
    Accept: 'application/json',
    'X-CSRF-Token': csrfToken
  };
}
